import { Tabs } from 'common/tabs/tab.js';
import { ColumnLayoutContext } from 'page-context/column-layout/column-layout-context.js';
import { useContext } from 'react';
import { GlossarySection } from './glossary-section.js';

export interface IGlossary {
  sections: IGlossarySection[];
}

export interface IGlossarySection {
  title: string;
  items: Array<IGlossaryItem>;
  key: string;
}

export interface IGlossaryItem {
  heading: IGlossaryLink;
  children?: IGlossaryLink[];
}

interface IGlossaryLink {
  label: string;
  url: string;
}

export interface ISectionProps {
  title: string;
  items: Array<IGlossaryItem>;
  classes?: string;
}

const SmallGlossaryComponent = ({ sections }: { sections: Array<IGlossarySection> }) => (
  <Tabs
    headers={sections.map(({ title }) => title)}
    className="Tab--slim"
    renderActiveTab={(activeTabIndex) => {
      const activeSection = sections[activeTabIndex];
      return <GlossarySection title={activeSection.title} items={activeSection.items} key={activeTabIndex} />;
    }}
  />
);

// @TODO Revisit this and check the number of search columns that can be sent
const LargeGlossaryComponent = ({ sections }: { sections: Array<IGlossarySection> }) => {
  return (
    <div className="Grid Grid--withGutter Section-Glossary--large u-flex">
      {sections.map(({ key, title, items }, i) => (
        <div key={key || i} className="u-flex-1 col-gutter">
          <GlossarySection title={title} items={items} classes="u-mT-responsive" />
        </div>
      ))}
    </div>
  );
};

export const Glossary = ({ sections }: IGlossary) => {
  const isLarge = useContext(ColumnLayoutContext) !== '1-column';
  if (isLarge) {
    return <LargeGlossaryComponent sections={sections} />;
  }
  return <SmallGlossaryComponent sections={sections} />;
};
